import { render, staticRenderFns } from "./ProtocoloOcorrencia.vue?vue&type=template&id=335cbbc1&scoped=true"
import script from "./ProtocoloOcorrencia.vue?vue&type=script&lang=js"
export * from "./ProtocoloOcorrencia.vue?vue&type=script&lang=js"
import style0 from "./ProtocoloOcorrencia.vue?vue&type=style&index=0&id=335cbbc1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335cbbc1",
  null
  
)

export default component.exports